/* 🤖 this file was generated by svg-to-ts */
export const matIconPanorama: {
  name: 'panorama';
  data: string;
} = {
  name: 'panorama',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H3V6h18v12zm-6.5-7L11 15.51 8.5 12.5 5 17h14z"/></svg>`
};
